// seeksimple - product hero behavior (no gap + edge-aware wheel)
(function () {
  function enhance(root) {
    var viewport = root.querySelector('.seeksimple-viewport');
    if (!viewport) return;

    function canScrollLeft()  { return viewport.scrollLeft > 0; }
    function canScrollRight() {
      // 向右还能滚动？
      return Math.ceil(viewport.scrollLeft + viewport.clientWidth) < viewport.scrollWidth;
    }

    function wheelToHorizontal(e) {
      if (!root.contains(e.target)) return;

      var absY = Math.abs(e.deltaY), absX = Math.abs(e.deltaX);
      if (absY <= absX) return; // 横向滚轮/触控板手势，交给浏览器

      var goingDown = e.deltaY > 0;
      var goingUp   = e.deltaY < 0;

      // 只有在相册还能继续横向滚的方向上，才拦截纵向滚轮
      if ((goingDown && canScrollRight()) || (goingUp && canScrollLeft())) {
        e.preventDefault();
        viewport.scrollBy({ left: e.deltaY, behavior: 'smooth' });
      } else {
        // 到头/到尾：不拦截，交给页面向下/向上滚
        // 不做任何事，让事件冒泡
      }
    }

    // 同时绑 root 和 viewport，避免事件被外层吃掉
    root.addEventListener('wheel', wheelToHorizontal,  { passive:false });
    viewport.addEventListener('wheel', wheelToHorizontal, { passive:false });

    // 鼠标拖拽（桌面端）
    var isDown=false, startX=0, startLeft=0;
    viewport.addEventListener('pointerdown', function(e){
      isDown=true; startX=e.pageX; startLeft=viewport.scrollLeft;
      viewport.setPointerCapture && viewport.setPointerCapture(e.pointerId);
      viewport.classList.add('is-dragging');
    });
    viewport.addEventListener('pointermove', function(e){
      if(!isDown) return;
      viewport.scrollLeft = startLeft + (startX - e.pageX);
    });
    ['pointerup','pointercancel','mouseleave'].forEach(function(ev){
      viewport.addEventListener(ev, function(){ isDown=false; viewport.classList.remove('is-dragging'); });
    });

    // Tabs
    var tabs   = root.querySelectorAll('.seeksimple-tab');
    var panels = root.querySelectorAll('.seeksimple-panel');
    tabs.forEach(function(btn){
      btn.addEventListener('click', function(){
        tabs.forEach(function(b){ b.classList.remove('is-active'); });
        panels.forEach(function(p){ p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var panel = root.querySelector('.seeksimple-panel[data-panel="'+btn.dataset.panel+'"]');
        if(panel) panel.classList.add('is-active');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-seeksimple-id]').forEach(enhance);
  });
})();
